module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Manage Blog Posts",
      "subtitle": ""
    }
  }, [_vm._c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "to": {
        name: 'blog-post-edit'
      }
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-plus"
  }), _vm._v("  Create Blog Post\n          ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('div', {
    staticClass: "filters"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm row"
  }, [_vm._c('label', {
    staticClass: "col-form-label col-xs-4 control-label"
  }, [_vm._v("Author")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-8"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAuthor),
      expression: "selectedAuthor"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.selectedAuthor = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.authorFilters), function(option) {
    return _vm._c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
  }))])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group form-group-sm"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search title..."
    },
    domProps: {
      "value": _vm._s(_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('DynamicTable', {
    attrs: {
      "data": _vm.filteredData,
      "fields": _vm.fields,
      "onClick": _vm.editRecord,
      "defaultSort": 'title'
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "settings-container"
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7851292!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/blog/blogmanager.vue
// module id = 722
// module chunks = 1